export default "__VITE_ASSET__Cl5to6BP__"